@use "stylesheets/utility/variables";

.ceremonyWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.alerts {
  margin: 0 20px;
  padding-bottom: 20px;
}

.ssLogo {
  margin: 20px 30px 0 12px;

  img {
    height: 37px;
    width: 161px;
  }
}

.geicoLogo {
  width: 93px;
  margin-top: 20px;

  &:hover {
    background-color: transparent;
  }

  @media screen and (max-width: variables.$mobileS) {
    margin-bottom: 10px;
  }
}
